export default "__VITE_ASSET__zamoGDfi__"